export const PROMPT_LIBRARY_NAV = {
  label: 'Prompt Library',
  path: '/prompt-library',
} as const;

export const isPromptLibraryPath = (pathname: string): boolean =>
  pathname.startsWith(PROMPT_LIBRARY_NAV.path);
